import merge from "lodash/merge";

export const BASIC_HIGHCHARTS_COLORS = [
    '#58B4F3',
    '#435462',
    '#F3E3A4',
    '#74BFE2',
    '#24CBE5',
    '#64E572',
    '#FF9655',
    '#FFF263',
    '#6AF9C4'
];

export const DEFAULT_HIGHCHARTS_OPTIONS: Highcharts.Options = {
    colors: BASIC_HIGHCHARTS_COLORS,
    chart: {
        style: {
            fontFamily: '"poppins-regular", sans-serif;'
        }
    },
    title: {
        text: "",
        style: {
            color: '#464644',
            font: 'bold 16px "poppins-bold", sans-serif;'
        }
    },
    subtitle: {
        text: "",
        style: {
            color: '#666666',
            font: 'bold 12px "poppins-semi-bold", sans-serif;'
        }
    },
    tooltip: {
        backgroundColor: 'rgb(228, 232, 230, 0.75)',
        style: {
            color: '#454951'
        }
    },
    legend: {
        itemStyle: {
            font: '9pt "poppins-regular", sans-serif;',
            color: 'black'
        },
        itemHoverStyle: {
            color: 'gray'
        }
    },
    credits: {
        enabled: false
    },
    accessibility: {
        enabled: false
    }
};

export const DEFAULT_HIGHCHARTS_PIE_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    chart: {
        type: "pie",
        plotBorderWidth: null,
        plotShadow: false,
        events: {
            load: function () {
                this.reflow();
            }
        },
    },
    tooltip: {
        headerFormat: "",
        pointFormat: "{point.name}: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})"
    },
    plotOptions: {
        pie: {
            shadow: false,
            center: ['50%', '40%'],
            size: '60%',
            innerSize: '40%',
            dataLabels: {
                padding: 2,
                connectorPadding: 2,
                distance: 10
            }
        }
    },
    series: {
        type: "pie"
    }
});

export const DEFAULT_HIGHCHARTS_AREA_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    chart: {
        type: "area"
    },
    accessibility: {
        point: {
            valueDescriptionFormat: '{index}. {point.category}, {point.y:,.0f} , {point.percentage:.1f}%.'
        }
    },
    tooltip: {
        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
        split: true
    },
    plotOptions: {
        area: {
            stacking: 'percent',
            lineWidth: 1,
            lineColor: "#ffffff",
            size: '100%',
            marker: {
                enabled: true,
                symbol: 'circle',
                radius: 3
            }
        }
    },
    xAxis: {
        labels: {
            style: {
                fontSize: "9px"
            }
        },
        title: {
            enabled: false
        }
    },
    yAxis: {
        title: {
            enabled: false
        }
    }
});

export const DEFAULT_HIGHCHARTS_3D_PIE_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    chart: {
        type: "pie",
        options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
        }
    },
    tooltip: {
        pointFormat: "{point.name}"
    },
    plotOptions: {
        pie: {
            edgeColor: "#ffffff",
            edgeWidth: 1,
            allowPointSelect: true,
            cursor: "pointer",
            depth: 50,
            size: "100%",
            dataLabels: {
                enabled: true,
                format: "{point.name}",
                padding: 2,
                connectorPadding: 2,
                distance: 5
            }
        }
    },
    series: {
        type: "pie"
    }
});

export const DEFAULT_HIGHCHARTS_BASIC_LINE_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    yAxis: {
        allowDecimals: false,
        title: {
            enabled: false
        }
    },
    xAxis: {
        labels: {
            style: {
                fontSize: "9px"
            }
        },
        title: {
            enabled: false
        }
    },
    plotOptions: {
        line: {
            lineWidth: 1,
            size: '100%',
            marker: {
                enabled: true,
                symbol: 'circle',
                radius: 3
            }
        }
    },
    tooltip: {
        split: true
    }
})

export const DEFAULT_HIGHCHARTS_SPLINE_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    chart: {
        type: "spline"
    },
    plotOptions: {
        spline: {
            size: "100%",
            marker: {
                enabled: false
            }
        }
    }
});

export const DEFAULT_HIGHCHARTS_STACKED_BAR_CHART_OPTIONS: Highcharts.Options = merge({}, DEFAULT_HIGHCHARTS_OPTIONS, {
    chart: {
        type: "bar"
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    yAxis: {
        labels: {
            style: {
                textOverflow: "none"
            }
        },
        title: {
            text: ""
        }
    }
});